<template>

    <div class="flex justify-content-between flex-wrap">
        <div class="flex align-items-center justify-content-center mb-3">
            <div class="flex">
                <div class="mr-2">
                    <div class="surface-card shadow-2 p-3 border-round-xl w-full ">
                        <label class="font-semibold" for="">PO Value:</label>
                        <label v-if="!summaryLoading" class="ml-2" for="">{{formatCurrency(poValue)}}</label>
                        <Skeleton v-if="summaryLoading" width="5rem" ></Skeleton>
                    </div>                   
                </div>
                <div class="mr-2">
                    <div class="surface-card shadow-2 p-3 border-round-xl w-full ">
                        <label class="font-semibold" for="">Billed:</label>
                        <label v-if="!summaryLoading" class="ml-2" for="">{{formatCurrency(billed)}}</label>
                        <Skeleton v-if="summaryLoading" width="5rem" ></Skeleton>
                    </div>
                </div>
                <div class="mr-2">
                    <div class="surface-card shadow-2 p-3 border-round-xl w-full ">
                        <label class="font-semibold" for="">Not Delivered:</label>
                        <label v-if="!summaryLoading" class="ml-2" for="">{{formatCurrency(notDelivered)}}</label>
                        <Skeleton v-if="summaryLoading" width="5rem" ></Skeleton>
                    </div>
                </div>
                <div class="mr-2">
                    <div class="surface-card shadow-2 p-3 border-round-xl w-full ">
                        <label class="font-semibold" for="">DC Not Recd:</label>
                        <label v-if="!summaryLoading" class="ml-2" for="">{{formatCurrency(challanNotRecd)}}</label>
                        <Skeleton v-if="summaryLoading" width="5rem" ></Skeleton>
                    </div>
                </div>
                <div class="mr-2">
                    <div class="surface-card shadow-2 p-3 border-round-xl w-full ">
                        <label class="font-semibold" for="">Avail Billing:</label>
                        <label v-if="!summaryLoading" class="ml-2" for="">{{formatCurrency(availBilling)}}</label>
                        <Skeleton v-if="summaryLoading" width="5rem" ></Skeleton>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex align-items-center justify-content-center mb-3">
            <Button icon="pi pi-file-excel" raised v-tooltip.top="'Export Items details'" @click="exportData($event)"/>
        </div>
    </div>
  <DataTable :value="orderItems" stripedRows showGridlines paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" scrollable scrollHeight="60vh" scrollDirection="both"  :loading="loading2" @filter="updateSummary" size="small" ref="itemsTable" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" v-model:filters="filters" filterDisplay="menu" :globalFilterFields="['name','deptPo','category.label', 'pendingQuantity', 'challanNotRecdQty', 'availableForBillQty','billedQty']">
        <Column header="Sl No" >
            <template #body="slotProps">
                {{ slotProps.index + 1 }}
            </template>
        </Column>
        <Column field="name" header="Item" style="min-width: 13rem">
            <template #body="slotProps">
                {{ slotProps.data.name }}
            </template>
            <template #filter="{ filterModel }">
                <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
            </template>
        </Column>
        <Column field="deptPo" header="PO No" >
            <template #body="slotProps">
                {{ slotProps.data.deptPo }}
            </template>
            <template #filter="{ filterModel }">
                <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
            </template>
        </Column>
        <Column field="deptPoDate" header="PO Date" style="min-width: 7rem">
            <template #body="slotProps">
                {{ slotProps.data.deptPoDate }}
            </template>
        </Column>
        <Column field="packing" header="Packing"  >
            <template #body="slotProps">
                {{ slotProps.data.packing }}
            </template>
        </Column>
        <Column field="quantity" header="Quantity"  >
            <template #body="slotProps">
                {{ formatNumber(slotProps.data.quantity) }}
            </template>
        </Column>
        <Column field="rate" header="Rate"  >
            <template #body="slotProps">
                {{ formatCurrency(slotProps.data.rate) }}
            </template>
        </Column>
        <Column field="sub_total" header="Sub Total"  >
            <template #body="slotProps">
                {{ formatCurrency(slotProps.data.sub_total) }}
            </template>
        </Column>
        <Column field="category.label" header="Category"  >
            <template #body="slotProps">
                {{ slotProps.data.category.label }}
            </template>
        </Column>

        <Column  header="Delivery Location">
        <template #body="slotProps">
            <span>
                <Button v-if="slotProps.data.location_status==1"  label="Show" size="small" icon="pi pi-external-link" @click="showLocations(slotProps.data)" />

                <Tag v-if="slotProps.data.location_status==0" value="Set Location" severity="warning"></Tag>
            </span>
        </template>
    </Column>         
    <Column header="OEM PO">
        <template #body="slotProps">
            <Button v-if="slotProps.data.location_status==1 && slotProps.data.order_status!='Ordered' && slotProps.data.cancel_surrender=='Active'" class="px-3 py-2" label="Generate" @click="generatePo(slotProps.data)"/>

            <label v-if="slotProps.data.location_status==0 && slotProps.data.cancel_surrender=='Active'">Set Location</label>
            <div v-for="(po, index) in slotProps.data.oemPo" :key="index">
                <Tag :value="po" severity="info"/>
            </div>
            
        </template>
    </Column> 
    <Column field="pendingQuantity" dataType="numeric" header="Pending Delivery"  >
        <template #body="slotProps">
            {{ formatNumber(slotProps.data.pendingQuantity) }}
        </template>
        <template #filter="{ filterModel }">
            <InputNumber v-model="filterModel.value" />
        </template>
    </Column>
    <Column field="pendingValue" header="Pending Value"  >
        <template #body="slotProps">
            {{ formatCurrency(slotProps.data.pendingValue) }}
        </template>
    </Column>
    

    <Column field="challanNotRecdQty" dataType="numeric" header="Not Recd Qty" >
        <template #body="slotProps">
            {{ formatNumber(slotProps.data.challanNotRecdQty) }}
        </template>
        <template #filter="{ filterModel }">
            <InputNumber v-model="filterModel.value" />
        </template>
    </Column>
    <Column field="notRecdValue" dataType="numeric" header="Not Recd Value" >
        <template #body="slotProps">
            {{ formatCurrency(slotProps.data.notRecdValue) }}
        </template>
        
    </Column>
    
    <Column field="availableForBillQty" dataType="numeric" header="Avl Billing Qty" >
        <template #body="slotProps">
            {{ formatNumber(slotProps.data.availableForBillQty) }}
        </template>
        <template #filter="{ filterModel }">
            <InputNumber v-model="filterModel.value" />
        </template>
    </Column>
    <Column field="availableForBill" dataType="numeric" header="Aval Billing" >
        <template #body="slotProps">
            {{ formatCurrency(slotProps.data.availableForBill) }}
        </template>
    </Column>  
     
    <Column field="billedQty" dataType="numeric" header="Billed Qty" >
        <template #body="slotProps">
            {{ formatNumber(slotProps.data.billedQty) }}
        </template>
        <template #filter="{ filterModel }">
            <InputNumber v-model="filterModel.value" />
        </template>
    </Column>
    <Column field="billedValue" dataType="numeric" header="Billed" >
        <template #body="slotProps">
            {{ formatCurrency(slotProps.data.billedValue) }}
        </template>
    </Column>
    </DataTable>

    <!-- Item location list Dialog -->
    <Dialog :visible="visible" modal :closable="false" :header="dialogHeader" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">                  
        <DataTable :value="itemDeliveryLocations" tableStyle="min-width: 30rem">
            <Column field="location" header="Location"></Column>
            <Column field="quantity" header="Quantity"></Column>
            <Column header="Update">
                <template #body="slotProps">
                    <Button label="Change" icon="pi pi-pencil" size="small" raised @click="updateLocation(slotProps.data)"/>
                </template>
            </Column>
            <Column field="prevLocation" header="Prev. Location"></Column>
        </DataTable>
        <div class="flex justify-content-end flex-wrap">
            <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="danger" rounded @click="visible=false"></Button>
        </div>
    </Dialog>

    <Dialog :visible="changeDeliveryLocationDialog" modal :closable="false" :header="deliveredStockHeader" :style="{ width: '100rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <div class="grid">
            <div class="col-3">
                <label class="font-medium">Location:</label>
                <InputText v-model="oldLocation.location" class="w-full" disabled/>
            </div>
            <div class="col ">
                <label class="font-medium">Quantity:</label>
                <InputNumber v-model="oldLocation.quantity" class="w-full" disabled/>
            </div>
            <div class="col-3">
                <label class="font-medium">New Location:</label>
                <!-- <div> -->
                    <Dropdown v-model="newLocation" :options="dbLocations" optionLabel="name" optionValue="id" class="w-full" filter placeholder="Select new location"/>
                <!-- </div> -->
            </div>
            <div class="col">
                <label class="font-medium">Re-Locate Qty:</label>
                <InputNumber v-model="newQuantity" class="w-full" />
            </div>
            <div class="col">
                <label class="font-medium">Remarks:</label>
                <InputText v-model="reLocateRemarks" class="w-full" placeholder="Reason for Re-location" />
            </div>
        </div>

        <template #footer>
            <div class="flex justify-content-end flex-wrap">
                <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Update" severity="success" raised @click="saveNewLocation"></Button>
                <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="danger" text raised @click="changeDeliveryLocationDialog=false"></Button>
            </div>
        </template>
    </Dialog>
</template>

<script>
import { getDeliveryLocation, getDeliveryLocations, preCheckRelocate, reLocateBeforeChallan } from '@/services/apiService';
import Button from 'primevue/button';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Tag from 'primevue/tag';
import { FilterMatchMode, FilterOperator  } from 'primevue/api'
import { useDeptPoStore } from '@/stores/deptPoStore';
import { deptOrdersItems } from '@/services/api/v2/apis';
import Skeleton from 'primevue/skeleton';

export default {
    name:'OrderItemsComponent',
    // props:{
        //     data:Array,
        //     loading:Boolean,
        // },
        components:{
            DataTable,
            Column,
            Button,
            Tag,
        InputText,
        InputNumber,
        Dropdown,
        Dialog,
        Skeleton,
    },
    data(){
        return{
            orderItems:[],
            loading2:false,
            dbLocations:[],
            visible:false,
            changeDeliveryLocationDialog:false,
            dialogHeader:null,
            itemId:null,
            itemDeliveryLocations:[],
            oldLocation:null,
            newQuantity:0,
            deliveredStockHeader:null,
            newLocation:null,
            reLocateRemarks:null,
            filters:{
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },  
                name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },   
                deptPo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }, 
                pendingQuantity: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                challanNotRecdQty: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },  
                billedQty: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }, 
                availableForBillQty: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },

            },
            poValue:0,
            billed:0,
            notDelivered:0,
            challanNotRecd:0,
            availBilling:0,
            summaryLoading:true,
        }
    },
    mounted(){        
        this.orderItems = this.data;
        this.loading2 = this.loading;
        this.fetchData();
        this.getLocations();
    },
    methods:{
        async fetchData(){
            try {
                this.loading2 = true;
                this.orderItems = [];
                const response = await deptOrdersItems([]);
                this.orderItems = response.data;
                this.summaryCalculator(this.orderItems);
                
                this.loading2 = false;
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.loading2 = false;
            }
        },
        getLocations(){
            getDeliveryLocations().then((res)=> 
                {
                    this.dbLocations = res.data
                }
                ).catch((error)=>this.showErrorToast(error.response.data));
        },
        showLocations(data){
            // this.spinnerLoadingStatus = true;
            this.loading2 = true;
            this.itemId = data;            
            getDeliveryLocation(data.id).then((res)=>{
                this.loading2 = false;
                this.dialogHeader = data.name;
                this.itemDeliveryLocations = [];
                if(res.data.length>0){
                    this.itemDeliveryLocations = {...res.data};
                    this.visible = true;
                }
            }).catch((error)=>{
                this.showErrorToast(error.response.data)
                this.loading2 = false;               
            })
        },
        updateLocation(location){
            
            preCheckRelocate(this.itemId.id, {locationId:location.locationId}).then((res)=>{
                if(res.data.status==1){
                    this.showErrorToast({message:'Challan generated. Location to be changed from Delivery Challan Module'});
                }
                if(res.data.status==0){
                    this.oldLocation = location;
                    this.newQuantity = location.quantity;
                    this.deliveredStockHeader = 'Update Location: '+this.itemId.name;
                    this.changeDeliveryLocationDialog = true;
                }
            }).catch((error)=>{
                this.showErrorToast(error.response.data)
            })
        },
        saveNewLocation(){

            if(this.newQuantity > this.oldLocation.quantity){
                return this.showErrorToast({message:'Re-locate quantity cannot be greater than previous quantity'});
            }
            if(this.newLocation==null || this.newLocation==undefined){
                return this.showErrorToast({message:'New location cannot be empty'});
            }
            if(this.newQuantity==0){
                return this.showErrorToast({message:'Re-locate quantity cannot be zero'});
            }

            const data = {
                itemId:this.itemId.id,
                oldLocationId:this.oldLocation.id,
                oldQuantity:this.oldLocation.quantity,
                newLocation:this.newLocation,
                newQuantity:this.newQuantity,
                remarks:this.reLocateRemarks,
            }

            this.loading2 = true;
            reLocateBeforeChallan(data).then((res)=>{
                this.showSuccessToast(res.data)
                this.changeDeliveryLocationDialog = false
                this.visible = false;
                this.loading2 = false;
                this.newLocation = null;
                this.reLocateRemarks = null;
                this.fetchData();
            }).catch((e)=>{
                this.showErrorToast(e.response.data)
                this.visible = false;
                this.loading2 = false;
            })

        },
        generatePo(data){            
            const store = useDeptPoStore();
            store.$patch({
                data:{
                    data,
                    poNo:data.deptPo
                },
            });
            this.$router.push('add-oem-po');
        },
        updateSummary(event){
            this.summaryLoading = true;
            this.summaryLoading = this.summaryCalculator(event.filteredValue);
        },
        summaryCalculator(data){
            this.poValue = this.billed = this.notDelivered = this.challanNotRecd = this.availBilling = 0;
            this.poValue = data.reduce((acc, item) => acc + item.sub_total, 0);            
            this.billed = data.reduce((acc, item) => acc + item.billedValue, 0);
            this.notDelivered = data.reduce((acc, item) => acc + item.pendingValue, 0);
            this.challanNotRecd = data.reduce((acc, item) => acc + item.notRecdValue, 0);
            this.availBilling = data.reduce((acc, item) => acc + item.availableForBill, 0); 
            return false;
        },
        formatCurrency(value) {
            if (value == null || isNaN(value)) return '-';
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        formatNumber(value) {
                return value.toLocaleString('en-IN');
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        exportData(){
            this.$refs.itemsTable.exportCSV();
        },
    }

}
</script>

<style>

</style>